import React, { useState, useEffect, useGlobal } from 'reactn';

import Loader from "shared-anpost-components/components/loader/Loader";

import { SingleItemHistoryStyled } from './SingleItemHistoryStyled';
import DeliveryItemOverview from '../../_core/deliveryItemOverview';
import DeliveryHistoryTimeline from '../../_core/deliveryHistoryTimeline';
import ReceivedItemsInfoBanner from '../../_core/receivedItemsInfoBanner';
import DropDownButton from '../../_core/DropDownButton';
import CustomsChargesView from '../../_core/customsChargesOverview';
import profileHooks from '../../../hooks/profileHooks';
import deliveryHooks from '../../../hooks/deliveryHooks';
import { pushDataLayer } from '../../../helpers/Helpers';
import { getAutoDib, getDeliveryManager, getTrackingHistory } from '../../../services/Api';

const SingleItemHistory = () => {
    const [selectedTrackingItem, setSelectedTrackingItem] = useGlobal("selectedTrackingItem");
    const [loading, setLoading] = useState(false);
    const [autoDib, setAutoDib] = useState(null);
    const [deliveryManagerGet, setDeliveryManagerGet] = useState();
    const { values } = profileHooks();
    const [newTrackingItems, setNewTrackingItems] = useState();
    const [refetch, setRefetch] = useGlobal('refetch');
    const [showBanner, setShowBanner] = useState(false);
    const [showDropDown, setShowDropDown] = useState(false);
    const [originalDeliveryAddress, setOriginalDeliveryAddress] = useGlobal("originalDeliveryAddress");
    const [mappedResults, setMappedResults] = useState([]);
    const [indexMapping] = useGlobal("manageDeliveriesDropdownButtonIndexMapping");
    const { getManageDeliveriesDropdownOptions } = deliveryHooks();

    useEffect(() => {
        window.dataLayer.push({
          event: "virtualPageView",
          pageview_url: `${window.location.pathname}/item-details`,
          pageview_title: `${document.title} - Item details`
        });
    }, [])

    useEffect(() => {
        let isMounted = true;

        getAutoDib(values.ciamUserId).then((res) => {
            if (isMounted) {
                setAutoDib(res.data.autoDIB.filter(item => item.emailAddress));
            }
        });

        return () => {
            isMounted = false;
        };
    }, [values.ciamUserId, refetch]);

    useEffect(() => {
        getTrackingHistory(values.ciamUserId).then((trackingData) => {
            const trackingItem = trackingData.data.trackingItems.find(item => item.trackingNumber === selectedTrackingItem.trackingNumber);
            setNewTrackingItems(trackingItem)
            // setSelectedTrackingItem(trackingItem);
            if (!trackingItem.deliveryManagerAvailable && !trackingItem.deliveryManagerInstructionDetail && !trackingItem.deliveryManagerInstructionSet
            ) {
                setDeliveryManagerGet(null)
                return
            }

            if (selectedTrackingItem && selectedTrackingItem.deliveryManagerAvailable) {
              setShowDropDown(true)
            }

            getDeliveryManager(values.ciamUserId, [trackingItem.trackingNumber]).then((res) => {
              if(res.data.statuses[0].originalDeliveryAddress) {
                  setOriginalDeliveryAddress(res.data.statuses[0].originalDeliveryAddress);
              }
              
              setDeliveryManagerGet(res.data.statuses[0]);
              if(res.data.statuses[0].availableServices) {
                  return res.data.statuses[0].availableServices;
              }
              return null;
            }).then((res) => {
              if (res) {
                if (res.includes("Y")) {
                  const newMappedResults = getManageDeliveriesDropdownOptions(indexMapping, res);
                  
                  setMappedResults(newMappedResults);
                } else {
                  setShowDropDown(false);
                }
              }
            });
        });
      
        if (selectedTrackingItem !== null) {
          if (selectedTrackingItem.lastTrackingEventCategoryId === "7") {
            getTrackingHistory(values.ciamUserId, selectedTrackingItem.trackingNumber).then((res) => {
              const trackingItemHistoriesArray = res.data.trackingItemHistories;
              const allWebCategoryIdIs7 = trackingItemHistoriesArray.every(item => item.webCategoryId === "7");

              if (allWebCategoryIdIs7) {
                const dateString = trackingItemHistoriesArray[0].date;

                // Convert string to date object
                const dateObject = new Date(dateString);

                // Get the current date and time
                const currentDate = new Date();

                // Check if the date is more than 24 hours ago
                const timeDifference = currentDate - dateObject;
                const isMoreThan24HoursAgo = timeDifference > (24 * 60 * 60 * 1000);

                if (isMoreThan24HoursAgo) {
                  setShowBanner(true);
                }
              } else {
                setShowBanner(false);    
              }
            });
          } else {
            setShowBanner(false);
          }
        }
      }, [selectedTrackingItem, autoDib, refetch]);

    useEffect(() => {
      if (selectedTrackingItem && selectedTrackingItem.lastTrackingEventCategoryId === "1" && selectedTrackingItem.customsPaymentRequired) {
        pushDataLayer({
          event: "customsToBeActioned",
        });
      }
    }, [selectedTrackingItem]);

    const customChargesClick = () => {
      window.location.href = `${window.location.origin}/Post-Parcels/Receiving/Pay-Customs-Charge?revenueNumber=${selectedTrackingItem.mrn}&trackingNumber=${selectedTrackingItem.trackingNumber}`;
    };

    return (
        <SingleItemHistoryStyled>
            {loading && <Loader />}
            {(selectedTrackingItem && autoDib) && <><div className='cardWrapper'><DeliveryItemOverview trackingItem={newTrackingItems} deliveryManagerGet={deliveryManagerGet} autoDib={autoDib} /><span className='textNotes'>
                <b>Note:</b> This information is only for confirming delivery of parcels delivered by An Post. It is an offence under Section 53 of the Communications Regulation (Postal Services) Act 2011 to use information obtained from a postal parcel for any other purpose.
            </span></div>
                <div className='cardWrapper'>
                  {showBanner && (
                    <ReceivedItemsInfoBanner />
                  )}
                  
                  {showDropDown && (
                    <DropDownButton
                      dropDownItems={mappedResults}
                      deliveryManagerResults={deliveryManagerGet}
                    />
                  )}
                  
                  {selectedTrackingItem.lastTrackingEventCategoryId === "1" && selectedTrackingItem.customsPaymentRequired && <CustomsChargesView customsRedirectHandler={customChargesClick} />}
                  
                  <DeliveryHistoryTimeline permaExpand trackingItem={selectedTrackingItem} />
                </div></>}
        </SingleItemHistoryStyled>
    );
};

export default SingleItemHistory;